import { extendObservable, action } from 'mobx';

export class UserCredential {
  constructor(props = {}) {
    const {
      email = "",
      password = "",
    } = props;

    extendObservable(this, {
      email: email,
      password: password,
    });
  }

  set = action((props = {}) => {
    for (let key in props) {
      this[key] = props[key];
    }
  });

  get = () => {
    return JSON.parse(JSON.stringify(this));
  }
}

export default UserCredential;


// WEBPACK FOOTER //
// ./src/models/UserCredential.js